import {IDirective, IDirectiveFactory, IDirectiveLinkFn, IScope, IAugmentedJQuery, IAttributes} from 'angular';
import {TSRefreshEvent} from '../../events/TSRefreshEvent';

/**
 * Direktive zum refreshen von SmartTable von ausserhalb
 */
export default class DVStTableRefresh implements IDirective {

    restrict = 'A';
    require = 'stTable';

    link: IDirectiveLinkFn;

    /* @ngInject */
    constructor() {

        this.link = (scope: IScope, element: IAugmentedJQuery, attrs: IAttributes, ctrl: any) => {
            if (!ctrl) {
                return;
            }

            scope.$on(TSRefreshEvent[TSRefreshEvent.REFRESH_ST_TABLE], function () {
                ctrl.pipe(ctrl.tableState());
            });

        };
    }

    static factory(): IDirectiveFactory {
        return () => new DVStTableRefresh();
    }
}




// WEBPACK FOOTER //
// ./src/app/core/directive/dv-st-table-refresh/dv-st-table-refresh.ts